import type { ModalInfoProps } from '@/components/ModalInfo';
import { ModalInfo } from '@/components';
import { Flex, Box, ArrowUpRightBoxIcon } from '@blockanalitica/ui';

export default function SparkLiquidityLayerModal({
  ...rest
}: Partial<ModalInfoProps>) {
  return (
    <ModalInfo title="What is the Spark Liquidity Layer?" {...rest}>
      <Flex flexDirection="column" gap="2xs">
        <Box>
          The Spark Liquidity Layer (SLL) automates liquidity provision of USDS,
          sUSDS, and USDC directly from Sky across various blockchain networks
          and DeFi protocols. This enables users to easily earn the Sky Savings
          Rate on their preferred network using sUSDS. Additionally, it allows
          Spark to automate liquidity provision into DeFi markets to optimize
          yield.
        </Box>
        <Flex
          as="a"
          display="inline-flex"
          // @ts-ignore
          href="https://docs.spark.fi/user-guides/spark-liquidity-layer/"
          target="_blank"
          rel="noopener noreferrer">
          Learn more
          <ArrowUpRightBoxIcon size="-1" />
        </Flex>
      </Flex>
    </ModalInfo>
  );
}
